import useFeedbackDialog from '@/hooks/useFeedbackDialog';
import CompactLayout from '@/layouts/CompactLayout';

export default function MainLayout({ children }: { children: React.ReactNode }) {
  const { FeedbackOverlay, FeedbackButton } = useFeedbackDialog();

  return (
    <CompactLayout feedbackButton={<FeedbackButton />} feedbackOverlay={<FeedbackOverlay />}>
      {children}
    </CompactLayout>
  );
}
